import gql from "graphql-tag";
import { ENTITY_VALUES_FRAGMENT } from "../EntityDetail/queries";

export const GET_PROCESS_HISTORY = gql`
    query getProcessHistory($id: ID!, $entityUlid: ID!) {
        process(id: $id) {
            id
            uid
            title
            hasProcessHistory
            processHistory {
                component
                reportUrl
            }
            created
            finished
        }
        entity(id: $entityUlid) {
            ...EntityValues
        }
        EntitySchema: jsonSchema(schema: "arachnys.entities.Entity")
    }
    ${ENTITY_VALUES_FRAGMENT}
`;

const PROCESS_EVENTS_FRAGMENT = gql`
    fragment processHistoryEvents on Process {
        events {
            jsonSchema_
            user {
                id
                username
            }
            task {
                entity(isHistorical: true) {
                    name
                }
                started
                finished
            }
            taskId
            taskName
            action
            detail
        }
    }
`;

export const GET_PROCESS_NARRATIVE = gql`
    query getProcessHistory($id: ID!) {
        process(id: $id) {
            id
            ...processHistoryEvents
        }
    }
    ${PROCESS_EVENTS_FRAGMENT}
`;

export const GET_PROCESS_DISPOSITION = gql`
    query getProcessHistory($id: ID!) {
        process(id: $id) {
            id
            processHistory {
                historyInput
            }
            ...processHistoryEvents
        }
    }
    ${PROCESS_EVENTS_FRAGMENT}
`;

export const GET_LOBS_HISTORY = gql`
    query getLobsTerminationHistory($id: ID!, $entityUlid: String!) {
        lobTermination(entityUlid: $entityUlid) {
            entityUlid
            lineOfBusiness: lobType
            timestamp
        }
        process(id: $id) {
            id
            processHistory {
                historyInput
            }
        }
        monitoringChanges(entityUlid: $entityUlid) {
            entityUlid
            oldMonitoringLevel
            newMonitoringLevel
            oldFrequency
            newFrequency
            timestamp
            jsonSchema_
        }
    }
`;
